var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSunlightNotmuch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    enableBackground: "new 0 0 36 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M18,5.5c0.46,0,0.834-0.373,0.834-0.833V1.333C18.834,0.873,18.46,0.5,18,0.5s-0.833,0.373-0.833,0.833 v3.333C17.167,5.127,17.54,5.5,18,5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M28.025,9.17l2.35-2.367c0.324-0.327,0.322-0.854-0.004-1.178c-0.327-0.325-0.855-0.323-1.18,0.004 l-2.35,2.367c-0.324,0.327-0.322,0.854,0.004,1.179C27.173,9.499,27.7,9.497,28.025,9.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M11.664,14c1.329-2.101,3.667-3.5,6.336-3.5s5.008,1.399,6.337,3.5h1.9 C24.751,10.944,21.626,8.833,18,8.833c-3.626,0-6.751,2.111-8.238,5.167H11.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M7.976,9.17C8.3,9.497,8.827,9.499,9.154,9.175s0.329-0.852,0.004-1.179l-2.35-2.367 C6.484,5.303,5.956,5.301,5.629,5.625C5.303,5.95,5.301,6.477,5.625,6.804L7.976,9.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSunlightNotmuch);
export default __webpack_public_path__ + "static/media/icon-sunlight-notmuch.d7bac98a9e944311903498af445033a7.svg";
export { ForwardRef as ReactComponent };